import React from 'react';
import './Header.css';

import BlackGoldLogo from '../../assets/dealershipsLogos/BlackGold.jpeg';
import RNChandler from '../../assets/dealershipsLogos/RNChandlerEuro.png';
import RNChandlerHarley from '../../assets/dealershipsLogos/chandlerharleydavidson.png';
import IndianTucson from '../../assets/dealershipsLogos/IndianTucson.png';
import RoadRunner from '../../assets/dealershipsLogos/RoadRunner.png';
import CentralTexas from '../../assets/dealershipsLogos/CentralTexas.png';
import Arrowhead from '../../assets/dealershipsLogos/arrowhead.png';
import SinCityIndian from '../../assets/dealershipsLogos/SinCityIndian.png';
import TucsonHarleyDavidson from '../../assets/dealershipsLogos/tucsonhardleydavidson.png';
import IndianDaytonaBeach from '../../assets/dealershipsLogos/IndianDaytonaBeach.png';
import WarHorse from '../../assets/dealershipsLogos/WarHorse.png';
import OldPueblo from '../../assets/dealershipsLogos/OldPueblo.png';
import Hammond from '../../assets/dealershipsLogos/Hammond.png';

import DealerNamesandLogos from '../../DealerNames and Logo.json';

// {
//   "AccountName": "RideNow Powersports Tri-Cities",
//   "Website": "https://www.ridenowtricities.com/",
//   "UploadDealerLogoImgUri": "d503b7a7-35a1-44c0-859e-78c7cfe70715.png"
// },

const dealerships = [
  {
    name: 'Hammond',
    logo: Hammond,
    url: 'https://blackgoldhd.com/',
  },
  {
    name: 'RNChandler',
    logo: RNChandler,
    url: 'https://www.ridenowchandler.com/',
  },
  {
    name: 'RNChandlerHarley',
    logo: RNChandlerHarley,
    url: 'https://chandlerharley.com',
  },
  {
    name: 'IndianTucson',
    logo: IndianTucson,
    url: 'https://www.ridenowtucsoneast.com/',
  },
  {
    name: 'RoadRunner',
    logo: RoadRunner,
    url: 'https://roadrunnerharley.com',
  },
  {
    name: 'CentralTexas',
    logo: CentralTexas,
    url: 'https://centraltexasharley.com',
  },
  {
    name: 'Arrowhead',
    logo: Arrowhead,
    url: 'https://arrowheadharley.com',
  },
  {
    name: 'SinCityIndian',
    logo: SinCityIndian,
    url: 'https://ducatilasvegas.com',
  },
  {
    name: 'TucsonHarleyDavidson',
    logo: TucsonHarleyDavidson,
    url: 'https://tucsonharley.com',
  },
  {
    name: 'IndianDaytonaBeach',
    logo: IndianDaytonaBeach,
    url: 'https://www.indianmotorcycledaytonabeach.com/',
  },
  {
    name: 'WarHorse',
    logo: WarHorse,
    url: 'https://warhorseharley.com',
  },
  {
    name: 'OldPueblo',
    logo: OldPueblo,
    url: 'https://oldpuebloharley.com',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
  {
    name: 'asdasdasdsa',
    logo: '',
    url: '',
  },
];

export const Header = () => {
  return (
    <div className="header-container">
      {DealerNamesandLogos.map((dealership) => {
        return (
          dealership?.UploadDealerLogoImgUri &&
          dealership.Website &&
          dealership.AccountName && (
            <div className="dealership-container">
              <img
                style={{ objectFit: 'contain', background: '#ffffff' }}
                src={`https://sellimg.rumbleon.com/dealerlogos/${dealership.UploadDealerLogoImgUri}`}
                // width={'80%'}
                // height={'80%'}
                onClick={() => window.open(dealership.Website, '_blank')}
              />
            </div>
          )
        );
      })}
    </div>
  );
};
